var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-content__profile"},[_c('p',{staticClass:"modal-content__profile__intro"},[_vm._v(" "+_vm._s(_vm.$trans('feedback.hello_you', 'front_feedback', { firstName: _vm.myFirstName }))+" ")]),_c('p',{staticClass:"modal-content__profile__intro modal-content__profile__intro--secondary",domProps:{"innerHTML":_vm._s(
            _vm.$trans(
                _vm.formType === 'business_connection_rdv_for_partner_contact'
                    ? 'feedback.we_connected_you.business_connection_after_rdv'
                    : 'feedback.we_connected_you.business_connection',
                'front_feedback',
                {
                    date: _vm.connectionDate,
                    fullName: _vm.connectedMemberFullName,
                    company: _vm.connectedMemberCompany,
                }
            )
        )}})])}
var staticRenderFns = []

export { render, staticRenderFns }